import { enums } from '@kattana-io/common';

const decoratePriceAlertStatus = (status: string) => {
  switch (status) {
  case enums.PriceAlertStatus.WATCH:
    return 'OPEN';
  case enums.PriceAlertStatus.FIRED:
    return 'NOTIFIED';
  case enums.PriceAlertStatus.CONSUMED:
    return 'COMPLETED';
  default:
    return status;
  }
};

const decorateLimitOrderStatus = (status: string) => {
  switch (status) {
  case enums.LimitOrderStatus.WATCH:
    return 'OPEN';
  case enums.LimitOrderStatus.CONSUMED:
    return 'COMPLETED';
  case enums.LimitOrderStatus.FIRED:
    return 'FILLED';
  default:
    return status;
  }
};

const decorateExchangeName = (exchange: string) => {
  switch (exchange) {
  case 'maiar':
    return 'xExchange';
  case 'okxdex':
    return 'OKC DEX';
  default:
    return exchange;
  }
};

export {
  decoratePriceAlertStatus,
  decorateLimitOrderStatus,
  decorateExchangeName,
};
